import { MatExpansionModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { GridTableAccordionComponent } from './grid-table-accordion.component';
// import { RnplCommonModule } from 'common/src/modules';


@NgModule({
  declarations: [
    GridTableAccordionComponent
  ],
  exports: [
    GridTableAccordionComponent
  ],
  imports: [
    CommonModule,
    // RnplCommonModule,
    TranslateModule,
    MatExpansionModule
  ],
})
export class GridTableAccordionModule { }
